"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const app_store_download_png_1 = __importDefault(require("../../static/downloads/app-store-download.png"));
const app_store_download_2x_png_1 = __importDefault(require("../../static/downloads/app-store-download@2x.png"));
const Image_1 = __importDefault(require("../Image"));
const AppleDownload = (_a) => {
    var { height = "auto", width = "100%" } = _a, rest = __rest(_a, ["height", "width"]);
    return (react_1.default.createElement("div", Object.assign({ style: { width, height } }, rest),
        react_1.default.createElement(Image_1.default, { width: width, height: height, alt: "Apple Download", src: app_store_download_png_1.default, srcSet: `${app_store_download_png_1.default} 1x, ${app_store_download_2x_png_1.default} 2x` })));
};
exports.default = AppleDownload;
//# sourceMappingURL=AppStoreDownload.js.map